// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--majMG","slide":"dd31006766--slide--KLBLj"};